export default __webpack_public_path__ + "static/media/BrainBreak cards104.47a93d57.png";